import React from 'react';
import type { ProfileCardSetSource } from '../../types/profileCard';
import { useProfileCardImageUrl } from '../../utils/profileCardImageCache';

type Props = {
  source: ProfileCardSetSource;
  storagePath?: string | null;
  imageVersion?: number | null;
  /** 드래프트 로컬 미리보기(우선) */
  previewUrl?: string | null;
  alt?: string;
  className?: string;
};

/** 프로필 카드 이미지: 버전 비교 캐시 Blob URL 또는 로컬 preview */
const ProfileCardCachedImage: React.FC<Props> = ({
  source,
  storagePath,
  imageVersion,
  previewUrl,
  alt = '',
  className,
}) => {
  const cached = useProfileCardImageUrl(
    source,
    previewUrl ? null : storagePath,
    previewUrl ? null : imageVersion
  );
  const src = previewUrl || cached;
  if (!src) return null;
  return <img className={className} src={src} alt={alt} draggable={false} />;
};

export default ProfileCardCachedImage;
